"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOuter = exports.calculateContainerStyle = exports.calculateOuterStyle = exports.calculateCanvasTransformation = exports.calculateScale = void 0;

var calculate_player_size_1 = require("./utils/calculate-player-size");

var calculateScale = function calculateScale(_ref) {
  var canvasSize = _ref.canvasSize,
      compositionHeight = _ref.compositionHeight,
      compositionWidth = _ref.compositionWidth,
      previewSize = _ref.previewSize;
  var heightRatio = canvasSize.height / compositionHeight;
  var widthRatio = canvasSize.width / compositionWidth;
  var ratio = Math.min(heightRatio, widthRatio);
  return previewSize === 'auto' ? ratio : Number(previewSize);
};

exports.calculateScale = calculateScale;

var calculateCanvasTransformation = function calculateCanvasTransformation(_ref2) {
  var previewSize = _ref2.previewSize,
      compositionWidth = _ref2.compositionWidth,
      compositionHeight = _ref2.compositionHeight,
      canvasSize = _ref2.canvasSize;
  var scale = (0, exports.calculateScale)({
    canvasSize: canvasSize,
    compositionHeight: compositionHeight,
    compositionWidth: compositionWidth,
    previewSize: previewSize
  });
  var correction = 0 - (1 - scale) / 2;
  var xCorrection = correction * compositionWidth;
  var yCorrection = correction * compositionHeight;
  var width = compositionWidth * scale;
  var height = compositionHeight * scale;
  var centerX = canvasSize.width / 2 - width / 2;
  var centerY = canvasSize.height / 2 - height / 2;
  return {
    centerX: centerX,
    centerY: centerY,
    xCorrection: xCorrection,
    yCorrection: yCorrection,
    scale: scale
  };
};

exports.calculateCanvasTransformation = calculateCanvasTransformation;

var calculateOuterStyle = function calculateOuterStyle(_ref3) {
  var config = _ref3.config,
      style = _ref3.style,
      canvasSize = _ref3.canvasSize;

  if (!config) {
    return {};
  }

  return _objectSpread(_objectSpread({
    position: 'relative',
    overflow: 'hidden'
  }, (0, calculate_player_size_1.calculatePlayerSize)({
    compositionHeight: config.height,
    compositionWidth: config.width,
    currentSize: canvasSize,
    height: style === null || style === void 0 ? void 0 : style.height,
    width: style === null || style === void 0 ? void 0 : style.width
  })), style);
};

exports.calculateOuterStyle = calculateOuterStyle;

var calculateContainerStyle = function calculateContainerStyle(_ref4) {
  var config = _ref4.config,
      canvasSize = _ref4.canvasSize,
      layout = _ref4.layout,
      scale = _ref4.scale;

  if (!config || !canvasSize || !layout) {
    return {};
  }

  return {
    position: 'absolute',
    width: config.width,
    height: config.height,
    display: 'flex',
    transform: "scale(".concat(scale, ")"),
    marginLeft: layout.xCorrection,
    marginTop: layout.yCorrection,
    overflow: 'hidden'
  };
};

exports.calculateContainerStyle = calculateContainerStyle;

var calculateOuter = function calculateOuter(_ref5) {
  var layout = _ref5.layout,
      scale = _ref5.scale,
      config = _ref5.config;

  if (!layout || !config) {
    return {};
  }

  var centerX = layout.centerX,
      centerY = layout.centerY;
  return {
    width: config.width * scale,
    height: config.height * scale,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: centerX,
    top: centerY,
    overflow: 'hidden'
  };
};

exports.calculateOuter = calculateOuter;